import styled from 'styled-components'

export const Wrapper = styled.div<{ color: string }>`
  display: inline-flex;
  align-items: center;
  background: ${({ color }) => color};
  border-radius: 4px;
  color: white;
  font-weight: var(--font-medium);
  font-size: 13px;
  width: fit-content;
  padding: 5px 6px;
  gap: 4px;
  margin: 0 6px 6px 0;
  width: fit-content;

  & > svg {
    flex-shrink: 0;
    width: 12px;
    height: 12px;
    fill: white;
  }
`
